import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, MenuItem } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import enhanceWithClickOutside from 'react-click-outside';
import DeleteJobMenu from './DeleteJobMenu';

class JobControls extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      deleting: false,
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.requestDeleteJob = this.requestDeleteJob.bind(this);
    this.requestEditJob = this.requestEditJob.bind(this);
  }

  handleToggle(open) {
    if (open) {
      this.setState({ open });
    }
  }
  handleClickOutside() {
    this.setState({ open: false });
  }

  requestDeleteJob() {
    if (this.state.deleting) {
      return Promise.reject(new Error('Deleting'));
    }
    this.setState({ deleting: true });
    return this.props.requestDelete(this.props.job)
      .then(
        () => {
          this.setState({ open: false, deleting: false });
        },
        () => {
          this.setState({ open: false, deleting: false });
        },
      );
  }

  requestEditJob() {
    this.props.requestEdit(this.props.job);
  }

  render() {
    const { job } = this.props;
    const {
      open, deleting,
    } = this.state;
    const disabled = deleting;
    return (
      <Dropdown
        pullRight
        id={`survey-control-${job._id}`}
        onToggle={this.handleToggle}
        open={open}
        disabled={disabled}
      >
        <Dropdown.Toggle bsStyle="link" noCaret>
          <Fa name="ellipsis-h" />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {open &&
            <MenuItem disabled={disabled} onClick={this.requestEditJob}>
              <span><Fa name="edit" /> Edit</span>
            </MenuItem>
          }
          {open &&
            <DeleteJobMenu
              job={job}
              disabled={disabled}
              deleting={deleting}
              requestDelete={this.requestDeleteJob}
            />
          }
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

JobControls.propTypes = {
  job: PropTypes.shape({
    _id: PropTypes.oneOfType([
      PropTypes.string,
    ]).isRequired,
  }).isRequired,
  requestDelete: PropTypes.func,
  requestEdit: PropTypes.func,
};

JobControls.defaultProps = {
  requestDelete: () => Promise.reject(new Error('Need handler')),
  requestEdit: () => {},
};

export default enhanceWithClickOutside(JobControls);
